<template>
  <div class="menu-container">
    <div class="normal-menu">
      <router-link
        v-if="isAdmin || isSuperAdmin"
        class="menu-item"
        :to="{ name: 'e-zacma-visit-types' }"
        :active-class="'active'"
      >
        <span data-feather="shopping-bag"></span>
        <div>Grupy powodów wizyt</div>
      </router-link>
      <router-link
        v-if="isAdmin || isSuperAdmin"
        class="menu-item"
        :to="{ name: 'e-zacma-localizations' }"
        :active-class="'active'"
      >
        <span data-feather="home"></span>
        <div>Lokalizacje</div>
      </router-link>
      <router-link
        v-if="isSuperAdmin"
        class="menu-item"
        :to="{ name: 'e-zacma-scopes' }"
        :active-class="'active'"
      >
        <span data-feather="archive"></span>
        <div>Organizacje</div>
      </router-link>
      <router-link class="menu-item" :to="'/e-zacma/doctors'" :active-class="'active'">
        <span data-feather="users"></span>
        <div>Użytkownicy</div>
      </router-link>
      <router-link
        v-if="isAdmin || isSuperAdmin"
        class="menu-item"
        :to="{ name: 'e-zacma-sales-representatives' }"
        :active-class="'active'"
      >
        <span data-feather="crosshair"></span>
        <div>Przedstawiciele handlowi</div>
      </router-link>
      <router-link
        v-if="isAdmin || isSuperAdmin"
        class="menu-item"
        :to="{ name: 'e-zacma-templates' }"
        :active-class="'active'"
      >
        <span data-feather="edit"></span>
        <div>Szablony</div>
      </router-link>
      <router-link
        v-if="isAdminWithTabletOperations"
        class="menu-item"
        :to="{ name: 'e-zacma-tablets-doctor-list' }"
        :active-class="'active'"
      >
        <span data-feather="user-check"></span>
        <div><strong>TABLET</strong> - Personel</div>
      </router-link>
      <router-link
        v-if="isAdminWithTabletOperations"
        class="menu-item"
        :to="{ name: 'e-zacma-tablets-banners' }"
        :active-class="'active'"
      >
        <span data-feather="tablet"></span>
        <div><strong>TABLET</strong> - Reklamy</div>
      </router-link>
      <router-link
        v-if="isAdminWithTabletOperations"
        class="menu-item"
        :to="{ name: 'e-zacma-tablets-settings' }"
        :active-class="'active'"
      >
        <span data-feather="settings"></span>
        <div><strong>TABLET</strong> - Ustawienia</div>
      </router-link>
      <router-link
        v-if="isSuperAdmin"
        class="menu-item"
        :to="{ name: 'e-zacma-tablets-super-admin' }"
        :active-class="'active'"
      >
        <span data-feather="tablet"></span>
        <div><strong>TABLETY</strong></div>
      </router-link>
      <router-link
        v-if="isAdmin || isSuperAdmin"
        class="menu-item"
        :to="{ name: 'users' }"
        :active-class="'active'"
      >
        <span data-feather="users"></span>
        <div>Administratorzy</div>
      </router-link>
      <router-link class="menu-item" :to="{ name: 'profile' }" :active-class="'active'">
        <span data-feather="user"></span>
        <div>Zmiana hasła</div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Menu',
  data() {
    return {
      accountType: '',
      isTabletOperationsEnabled: false
    }
  },
  async mounted() {
    const vm = this
    vm.$store.commit('removePageLoaderEvent', 'login')
    vm.accountType = localStorage.getItem('account_type')
    vm.isTabletOperationsEnabled = localStorage.getItem('tablet_operations_enabled') === '1'
  },
  computed: {
    isAdmin() {
      return this.accountType === 'admin'
    },
    isAdminWithTabletOperations() {
      return this.accountType === 'admin' && this.isTabletOperationsEnabled
    },
    isSuperAdmin() {
      return this.accountType === 'super_admin'
    }
  }
}
</script>

<style lang="scss">
.menu-container {
  margin-left: 0;
  padding-top: 0;
}

@media (min-width: 768px) {
  .menu-container {
    margin-left: -200px;
    padding-top: 85px;
  }
}

.normal-menu {
  display: flex;
  gap: 15px;
  justify-content: center;
  flex-wrap: wrap;
  width: 80%;
  margin: 0 auto;
}

.menu-item {
  border: 1px solid gainsboro;
  width: 300px;
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 10px;
  outline: none;

  &:hover {
    background-color: #f5f5f5;
    outline: none;
    font-weight: bold;
    text-underline-mode: none;
  }
}
</style>
